/**
 * Extract a user-facing message from a failed API call.
 *
 * On a non-2xx response axios rejects with an AxiosError whose `.message` is a
 * generic "Request failed with status code N". The backend's real, friendly
 * message lives in `error.response.data.message`. This helper surfaces that,
 * falling back to a caller-supplied message when it is absent or blank.
 */
export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const serverMessage = (error as { response?: { data?: { message?: unknown } } })?.response?.data
    ?.message;
  if (typeof serverMessage === 'string' && serverMessage.trim().length > 0) {
    return serverMessage;
  }
  return fallback;
};
